import { v4 as uuidv4 } from 'uuid';
import { pallgrowDefects } from './pallgrow-steps';
import { Fruit } from '../interfaces/interfaces';
import { DetailObject, InitialPallets } from '../interfaces/intakes.reports';
import { UserSettings } from '../interfaces/interfaces.auth';
import { jsonKeyToString } from '../helpers/jsonToString';

// const coloration: Fruit[] = ["blueberries", "cherries", "pears"]
// const undersize: Fruit[] = ["pears"]
// const fruitPressure: Fruit[] = ["pears"]

export const palletData = (fruit: Fruit, samples: number = 1, formatGr: number, palletNumber: number, settings?: UserSettings | null): InitialPallets => {

    // PONE LOS ITEMS EN FALSE
    // const dataLabels:DetailObject[] = settings?.custom_fields.labels ? addLabels().map( label => ({ ...label, check: settings.custom_fields.labels?.includes(label.name as string) ? true : false})) : addLabels()
    // const dataAppearance:DetailObject[] = settings?.custom_fields.appearance ? addAppearance(fruit).map( label => ({ ...label, check: settings.custom_fields.appearance?.includes(label.name as string) ? true : false})) : addAppearance(fruit)

    // BORRA LOS OTROS ITEMS (OK MAR 16)
    // const dataLabels: DetailObject[] = settings?.custom_fields.labels ? addLabels().filter(label => settings.custom_fields.labels?.includes(label.name as string)) : addLabels()
    // const dataAppearance: DetailObject[] = settings?.custom_fields.appearance ? addAppearance().filter(label => settings.custom_fields.appearance?.includes(label.name as string)) : addAppearance()
    const dataLabels: DetailObject[] = dataWithPersonal("labels", settings)
    const dataAppearance: DetailObject[] = dataWithPersonal("appearance", settings)

    const minorDefects: DetailObject[] = settings?.custom_fields.pallgrow?.minor ? settings.custom_fields.pallgrow.minor.map( name => ({ check: false, label: jsonKeyToString(name), name: name, value: "0" })) : pallgrowDefects(fruit, "minor")
    const majorDefects: DetailObject[] = settings?.custom_fields.pallgrow?.major ? settings.custom_fields.pallgrow.major.map( name => ({ check: false, label: jsonKeyToString(name), name: name, value: "0" })) : pallgrowDefects(fruit, "major")

    return {
        pallet: palletNumber,
        complete: null,
        pid: uuidv4(),
        score: "0",
        grade: "0",
        action: "0",
        images: [],
        splitPallet: null,
        labels: { data: dataLabels, images: [] },
        appearance: { data: dataAppearance, images: [] },
        pallgrow: { data: pallgrowData(samples, formatGr), minor: minorDefects, major: majorDefects, images: [], },
        comments: ""
    }
}

export const dataWithPersonal = (property: "labels" | "appearance", settings?: UserSettings | null): DetailObject[] => {

    const selectedObject:DetailObject[] = property === "labels" ? addLabels() : addAppearance()
    const allowedFields:string[] | undefined = settings?.custom_fields[property]

    if( allowedFields ){
        return allowedFields.map( item => {
            const foundedItem = selectedObject.find( i => i.name === item)
            return foundedItem ? foundedItem : { check: true, label: jsonKeyToString(item), name: item, value: "" }
        } )
    }

    return selectedObject
}

export const validLabels = [
    "pallet_reference",
    "box_label",
    "pallet_type",
    "punnet_label",
    "name_weight",
    "l_code",
    "t_code",
    "ean_code",
    "variety",
]

export const validAppearance = [
    "pallet_integrity",
    "temperature_c",
    "insect",
    "fresh",
    "size",
    "coloration",

    "taste",
    "pollution",
    "humidity",
    "juicing",
    "wet_punnets",
    "brix",
    "weight_check",
]

export const addLabels = (): DetailObject[] => [
    { check: true, label: "Pallet Reference", name: "pallet_reference", value: "" },
    { check: true, label: "Box Label", name: "box_label", value: true },
    { check: true, label: "Pallet Type", name: "pallet_type", value: "" },
    { check: true, label: "Punnet Label", name: "punnet_label", value: true },

    { check: true, label: "Name & Weight", name: "name_weight", value: true },
    { check: true, label: "L Code", name: "l_code", value: "" },
    { check: true, label: "T Code", name: "t_code", value: "" },
    { check: true, label: "EAN Code", name: "ean_code", value: "" },
    { check: true, label: "Variety", name: "variety", value: "" },
]

export const addAppearance = (): DetailObject[] =>
    // let appearance = 
    [
        { check: true, label: "Pallet Integrity", name: "pallet_integrity", minVal: 1, maxVal: 10, value: "1" },
        { check: true, label: "Temperature C", name: "temperature_c", value: "" },

        { check: true, label: "Insect", name: "insect", value: true },
        { check: true, label: "Fresh", name: "fresh", minVal: 1, maxVal: 10, value: "1" },
        { check: true, label: "Size", name: "size", minVal: 1, maxVal: 10, value: "1" },
        { check: true, label: "Coloration", name: "coloration", minVal: 1, maxVal: 10, value: "1" },
        { check: true, label: "Taste", name: "taste", minVal: 1, maxVal: 10, value: "1" },
        { check: true, label: "Pollution", name: "pollution", value: true },
        { check: true, label: "Humidity", name: "humidity", value: true },
        { check: true, label: "Juicing", name: "juicing", value: true },
        { check: true, label: "Wet Punnets", name: "wet_punnets", value: true },

        { check: true, label: "Brix", name: "brix", value: ["", ""] },
        { check: true, label: "Weight Check", name: "weight_check", value: ["", "", "", ""] },
    ]
// let index = appearance.findIndex(item => item.label === "Coloration");

// if (index !== -1 && coloration.includes(fruit)) {
//     appearance.splice(index + 1, 0, { check: true, label: "Internal coloration", name: "internal_coloration", minVal: 1, maxVal: 10, value: "1" });
// }
// if (undersize.includes(fruit)) {
//     appearance.push({ check: true, label: "Undersize", name: "undersize", value: "" })
// }
// if (fruitPressure.includes(fruit)) {
//     appearance.push({ check: true, label: "Fruit pressure", name: "fruit_pressure", value: [""] })
// }

// return appearance
// }

export const pallgrowData = (samples: number, formatGr: number) => [
    { check: true, label: "Weight 10 Fruits", name: "weight_10", value: "" },
    { check: true, label: "Format Gr.", name: "format_gr", value: formatGr.toString() },
    { check: true, label: "Samples", name: "samples", value: samples.toString() },
]

// export const addPallgrow = (fruit: Fruit, defect: "minor" | "major") => {
//     if (fruit === "pears") { return pallgrowPears(defect) }
//     else if (fruit === "apples") { return pallgrowApples(defect) }
//     else if (fruit === "cherries") { return pallgrowCherries(defect) }
//     else if (fruit === "blueberries") { return pallgrowBlueberries(defect) }
//     else if (fruit === "blackberries") { return pallgrowBlackberries(defect) }
//     else if (fruit === "raspberries") { return pallgrowRaspberries(defect) }
//     else if (fruit === "strawberries") { return pallgrowStrawberries(defect) }
//     else if (fruit === "red currants") { return pallgrowRedCurrants(defect) }
//     else { return pallgrowBerries() }
// };